export const WECHAT_LOOP_TIMES = 40; // 轮询次数
export const WECHAT_LOOP_INTERVAL = 1500; // 轮询时间间隔
export var E_WECHAT_CODE_SCAN_TYPE;
(function (E_WECHAT_CODE_SCAN_TYPE) {
    E_WECHAT_CODE_SCAN_TYPE["LOGIN"] = "LOGIN";
    E_WECHAT_CODE_SCAN_TYPE["BIND"] = "BIND";
})(E_WECHAT_CODE_SCAN_TYPE || (E_WECHAT_CODE_SCAN_TYPE = {}));
export var E_WECHAT_STATUS;
(function (E_WECHAT_STATUS) {
    E_WECHAT_STATUS["OVERDUE"] = "OVERDUE";
    E_WECHAT_STATUS["SCANNED"] = "SCANNED";
    E_WECHAT_STATUS["LOADING"] = "LOADING";
    E_WECHAT_STATUS["FAIL"] = "FAIL";
    E_WECHAT_STATUS["SUCCESS"] = "SUCCESS";
})(E_WECHAT_STATUS || (E_WECHAT_STATUS = {}));
export var E_WECHAT_BIND_WAY;
(function (E_WECHAT_BIND_WAY) {
    E_WECHAT_BIND_WAY["EMAIL"] = "EMAIL";
    E_WECHAT_BIND_WAY["PHONE"] = "PHONE";
    /**
     * 安全验证
     */
    E_WECHAT_BIND_WAY["SECURITY_VERIFICATION"] = "SECURITY_VERIFICATION";
    /**
     * 已购注册
     */
    E_WECHAT_BIND_WAY["PURCHASED_REGISTER"] = "PURCHASED_REGISTER";
    /**
     * 申请试用
     */
    E_WECHAT_BIND_WAY["APPLY_TRIAL"] = "APPLY_TRIAL";
})(E_WECHAT_BIND_WAY || (E_WECHAT_BIND_WAY = {}));
